import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  readonly children: ReactNode;
}

export function GreyLabel({ children }: Readonly<Props>) {
  return (
    <Box component="span" sx={{ color: 'grey.600' }}>
      {children}
    </Box>
  );
}
